
import req from '../utils/request.js'

const comapi = {}

// code=identity_type 学科列表
// code=sex 用户性别
// code=professional_title 职称
// code=  举报原因
comapi.listmenu = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/dict/list', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 举报原因列表
comapi.reportReason = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/dict/dictionary', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 搜素框中的馆藏数量
comapi.collectionCount = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/pc/apiv1/home/getTenantCollectionNumber', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default comapi
